import {Typography, useTheme} from '@mui/material';
import Grid from '@mui/material/Grid';

import useProfile from '../../../../../hooks/providers/useProfile';
import {flowShape} from '../../../../../proptypes-shapes';
import {normaliseValue} from '../../../../../utils';
import CustomizedLinearProgress from '../../../../progress/LinearProgress';

const HeaderOnboardingSingleFlowProgressBar = ({flow}) => {
  const theme = useTheme();
  const {getTotalNumberOfOnboardingSteps, getNumberOfCompletedOnboardingSteps} = useProfile();
  const totalNumberOfSteps = getTotalNumberOfOnboardingSteps(flow.id);
  const completedSteps = getNumberOfCompletedOnboardingSteps(flow.id);
  const onboardingProgression = normaliseValue(completedSteps, totalNumberOfSteps);
  const roundedProgression = Math.floor(onboardingProgression);

  return (
    <Grid container alignItems="center">
      <CustomizedLinearProgress
        filledColor={theme.palette.primary.main}
        emptyColor={`${theme.palette.primary.main}30`}
        variant="determinate"
        value={roundedProgression}
        stylesOverrides={{
          height: 6,
          flex: 0.95
        }}
      />
      <Typography ml={1} fontSize={11} color="text.primary">
        {roundedProgression} %
      </Typography>
    </Grid>
  );
};

HeaderOnboardingSingleFlowProgressBar.propTypes = {
  flow: flowShape.isRequired
};

export default HeaderOnboardingSingleFlowProgressBar;
